import { jsx as _jsx } from "react/jsx-runtime";
import { RecurrenceEndEnum } from "generated/generated-models";
import DueOnListItems from "./DueOnListItems";
/**Wrapper of DueOnListItems designed for use in the receipt page */
const DueOnListItemsReceipt = ({ fundsTransfer, }) => {
    const endingOn = fundsTransfer.EndingOn
        ? new Date(fundsTransfer.EndingOn)
        : undefined;
    const startingOn = fundsTransfer.StartingOn
        ? new Date(fundsTransfer.StartingOn)
        : undefined;
    const getRecurrence = () => {
        if (fundsTransfer.FurtherNotice === true) {
            return RecurrenceEndEnum.Never;
        }
        if (fundsTransfer.SpecifiedDate === true) {
            return RecurrenceEndEnum.Bydate;
        }
        if (fundsTransfer.NumberOfTimes === true) {
            return RecurrenceEndEnum.Numberofocurrences;
        }
        return RecurrenceEndEnum.Once;
    };
    return (_jsx(DueOnListItems, { paymentDate: startingOn, frequency: fundsTransfer.Frequency || "", endDate: endingOn, repeats: fundsTransfer.NumberOfTimesAmount, recurrence: getRecurrence() }));
};
export default DueOnListItemsReceipt;
